import { config } from '../_config';
import { fakeLinkService as linksFS } from "./fake.links.serivce";
import { linkService as linksS } from "./links.service";
import { PatchNotesService as patchNotesS } from "./patch.notes.service";
import { ImportService as importS } from "./import.service";
import { ILinksService, ISettingDownloadService, IComponent, IPatchNotesComponent, IImportComponents, ISecureService } from '../_types/interfaces';
import { settingService as settingS } from './setting.download.service';
import { secureServices as secureS } from './secure.service';
import { fakeSettingService as settingFS} from './fake.setting.download.service';
import { componentService as componentS } from './components.service';
import { fakeComponentService as componentFS} from './fake.components.service';
import { fakePatchNotesService as patchNotesFS} from './fake.patch.notes.service';
import { fakeImportService as importFS} from './fake.import.service';
import { fakeSecureServices as secureFS} from './fake.secure.service';

export let componentService: IComponent;
export let linkService: ILinksService;
export let settingService: ISettingDownloadService;
export let patchNotes: IPatchNotesComponent;
export let importService: IImportComponents;
export let secureService: ISecureService;

if (config.useFake === true) {
    linkService = linksFS;
    settingService = settingFS
    componentService = componentFS
    patchNotes = patchNotesFS
    importService = importFS
    secureService = secureFS
} else {
    linkService = linksS;
    settingService = settingS
    componentService = componentS
    patchNotes = patchNotesS
    importService = importS
    secureService = secureS
}